import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { MicrosoftDocumentType } from '@/widgets/MicrosoftEmbed/types';

export function createNewMicrosoftEmbedData(documentType: MicrosoftDocumentType): ManifestInitializedProps {
  const id = genRandId();
  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.MicrosoftEmbed],
        ['documentType', documentType],
        ['children', new Y.Array()],
        ['title', ''],
        ['src', '']
      ])
    }
  ];
}
